(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["custom-multicolumn"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function() {
    $('.custom-multicolumn').slick({
      autoplay: false,
      arrows: true,
      dots: false,
      slidesToShow: 1,
      draggable: true,
      pauseOnHover: true,
      infinite: false,
      adaptiveHeight: true,
      adaptiveWidth: true
    });
  });
  console.log('a');


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-testimonials-v2"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function() {
    $('.testimonial-slider-v2').slick({
      autoplay: false,
      arrows: true,
      dots: false,
      slidesToShow: 1,
      draggable: true,
      pauseOnHover: true,
      infinite: true,
      adaptiveHeight: true,
      adaptiveWidth: true,
      responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 950,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
      ]
    });
  });
  
  console.log('testimonial 22223');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-testimonials-v3"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function() {
    $('.testimonial-slider-v3').slick({
      autoplay: false,
      arrows: true,
      dots: false,
      slidesToShow: 5,
      draggable: true,
      pauseOnHover: true,
      infinite: true,
      adaptiveHeight: true,
      adaptiveWidth: true,
      responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
                dots: true,
            }
        },
        {
            breakpoint: 950,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                dots: true,
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                dots: true,
            }
        }
      ]
    });
  });
  
  console.log('testimonial222');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-testimonials-v4"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function() {
    $('.testimonial-slider-v4').slick({
      autoplay: false,
      arrows: false,
      dots: false,
      slidesToShow: 5,
      draggable: true,
      pauseOnHover: true,
      infinite: true,
      adaptiveHeight: true,
      adaptiveWidth: true,
      centerMode: true,
      responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
            }
        },
        {
            breakpoint: 950,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
      ]
    });
  });
  
  console.log('testimonial 4');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-testimonials"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function() {
    $('.testimonial-slider').slick({
      autoplay: false,
      arrows: true,
      dots: true,
      slidesToShow: 3,
      draggable: false,
      pauseOnHover: true,
      infinite: false,
      adaptiveHeight: true,
      adaptiveWidth: true,
      responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
            }
        },
        {
            breakpoint: 950,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
      ]
    });
  });
  
  console.log('testimonial');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-v2"] && !window.DesignMode) return;
  try {
    
  $(".plus").on( "click", function( event ) {
    $(this).parent().attr("aria-expanded","true");
  });
  $(".minus").on( "click", function( event ) {
    $(this).parent().attr("aria-expanded","false");
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["figma-image-slider"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function() {
    $('.figma-image-slider').slick({
      autoplay: true,
      dots: true,
      arrows: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      draggable: true,
      pauseOnHover: true,
      infinite: true,
      adaptiveHeight: true,
      adaptiveWidth: true,
      centerMode: true,
      centerPadding: "20%",
      responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 950,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
      ]
    });
  });
  
  console.log('figma image slider ');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["figma-image-text-slider"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function() {
    $('.figma-text-image-slider').slick({
      autoplay: false,
      dots: false,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      draggable: true,
      pauseOnHover: true,
      infinite: true,
      adaptiveWidth: true
    });
  });
  
  console.log('figma text image slider ');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["figma-slider"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function() {
    $('.figma-slider-content').slick({
      autoplay: false,
      arrows: true,
      dots: false,
      slidesToShow: 3,
      draggable: true,
      pauseOnHover: true,
      infinite: false,
      adaptiveHeight: true,
      adaptiveWidth: true,
      responsive: [
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
      ]
    });
  });
  
  console.log('figma-slider');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["figma-testimonial-2"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function() {
    $('.figma-testimonial-slider-2').slick({
      autoplay: false,
      arrows: true,
      dots: true,
      slidesToShow: 3,
      draggable: true,
      pauseOnHover: true,
      infinite: false,
      adaptiveHeight: true,
      adaptiveWidth: true,
      responsive: [
        {
            breakpoint: 1300,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                dots: true
            }
        }
      ]
    });
  });
  
  console.log('figma-testimonial-slider-2');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["figma-testimonials"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function() {
    $('.figma-testimonial-slider').slick({
      autoplay: false,
      arrows: true,
      dots: false,
      slidesToShow: 4,
      draggable: true,
      pauseOnHover: true,
      infinite: true,
      adaptiveHeight: true,
      adaptiveWidth: true,
      responsive: [
        {
            breakpoint: 1300,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
      ]
    });
  });
  
  console.log('figma-testimonial-slider');

  } catch(e) { console.error(e); }
})();
      })();
